import React, { useEffect, useState, useContext } from 'react';
import '../styles/MyPicks.css';
import { getAllNomineesAndCategories, getWinners, saveWinners } from '../apiCalls/partyAPI';
import CategoryNominees from '../entities/categoryNominees';
import AuthContext from '../contexts/index';
import Pick from '../entities/pick';

import { useNavigate } from 'react-router-dom';


function SetWinners() {
    const visible = { visibility: 'visible' };
    const hidden = { visibility: 'hidden' };
    const [modalShow, setModalShow] = useState(hidden);
    const { user } = useContext(AuthContext);
    const [ nomineesAndCategories, setNomineesAndCategories ] = useState();
    const [ winners, setWinners ] = useState([]);
    const navigate = useNavigate();
    const oscarYear = new Date().getFullYear();


    useEffect(() => {
        if (!user) {
            console.log('🔄 SetWinners: user not loaded yet, skipping API call');
            return;
        }
        
        console.log(`📨 SetWinners: Fetching nominees for oscarYear=${oscarYear}`);
        setModalShow(visible);
        getAllNomineesAndCategories(oscarYear, user.credential)
        .then(nominees => {
            console.log(`✅ SetWinners: Loaded ${nominees.length} nominee categories`);
            return nominees.map(nominee => new CategoryNominees(nominee._id, nominee.category, nominee.oscarYear, nominee.nominees));
        })
        .then(nominees => setNomineesAndCategories(nominees))
        .then(() => {
            console.log('📋 SetWinners: Loading existing winners...');
            loadWinners();
        })
        .finally(() => setModalShow(hidden))
        .catch(error => {
            console.error('❌ SetWinners: Error loading nominees:', error);
        });
    }, [user, oscarYear]);
    
    const loadWinners = () => {
        if(!user){
            console.log('⚠️  SetWinners: Cannot load winners - user is null');
            return;
        }
        console.log(`🏆 SetWinners: Fetching winners for oscarYear=${oscarYear}`);
        getWinners(oscarYear, user.credential)
        .then((winners) => {
            console.log(`✅ SetWinners: Loaded ${winners.length} existing winners`);
            winners.forEach(winner => setWinnersFromAPI(winner));
        })
        .catch(error => {
            console.error('❌ SetWinners: Error loading winners:', error);
        });
    }

    const setWinnersFromAPI = (winner) => {
        const select = document.getElementById(winner.category);
        select.value = winner.name;
        setWinners(winners => [...winners, winner]);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(winners);
        saveWinners(winners, user.credential)
        .then(() => navigate("/"))
        .catch(error => console.log(error));
    }

    const screamingSnakeToPretty = (screamingSnake) => {
        return screamingSnake.replace(/_/g, " ");
    }

    return (
        <>
            <span className="loader" style={modalShow}></span>
            {
                nomineesAndCategories
                ?
                    <div className="container">
                        <h1>{nomineesAndCategories[0].oscarYear} Winners</h1>
                        <div className='row'>
                            <div className="col-md-6">
                                <form id="myPicks" onSubmit={handleSubmit}>
                                    {
                                        nomineesAndCategories.map(cat => 
                                            <div className="form-group" key={cat._id}>
                                                <label htmlFor="queryName">{screamingSnakeToPretty(cat.category)}</label>
                                                <select id={cat.category} name={cat.category} data-testid={cat.category+"-select"} className='form-control' onChange={ (e) => {
                                                    const newPick = new Pick(cat.category, e.target.value);
                                                    setWinners(prevWinners => {
                                                        // Find if this category already exists
                                                        const existingIndex = prevWinners.findIndex(w => w.category === cat.category);
                                                        if (existingIndex >= 0) {
                                                            // Update existing pick for this category
                                                            const updated = [...prevWinners];
                                                            updated[existingIndex] = newPick;
                                                            return updated;
                                                        } else {
                                                            // Add new pick for new category
                                                            return [...prevWinners, newPick];
                                                        }
                                                    });
                                                }} >
                                                    <option value="Select A Nominee" data-testid={cat.category+"-select-default"}>Select Winner</option>
                                                    {
                                                        cat.nominees.map((nominee,index) => <option value={nominee.name} key={index} data-testid={cat.category+index}>{nominee.name.toUpperCase()}{nominee.name2 ? " - "+nominee.name2 : ""}</option>)    
                                                    }
                                                </select>
                                            </div>
                                        )
                                    }
                                    <div className="form-group">
                                        <button type="submit" className="btn btn-success" data-testid="saveButton">Save</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                :
                    <>Loading</>
            }
        </>
    );
}

export default SetWinners;